import { useContext } from 'react';

import { ActiveOrgContext } from './ActiveOrgContext';
import { AuthenticationContext } from './AuthenticationContext';
import { LocationContext } from './LocationContext';
import { PermissionsContext } from './PermissionsContext';
import { SidebarContext } from './SidebarContext';
import { ThemeContext } from './ThemeContext';

const useActiveOrg = () => useContext(ActiveOrgContext);
const useAuthentication = () => useContext(AuthenticationContext);
const useLocationScope = () => useContext(LocationContext);
const usePermissions = () => useContext(PermissionsContext);
const useSidebar = () => useContext(SidebarContext);
const useTheme = () => useContext(ThemeContext);

export {
  useActiveOrg,
  useAuthentication,
  useLocationScope,
  usePermissions,
  useSidebar,
  useTheme,
};
